/**
 * Cập nhật <head> sau khi trang tải dữ liệu trên trình duyệt.
 *
 * Dùng cho bài Playbook mới xuất bản mà chưa có HTML tĩnh (Firebase phục vụ
 * khung /playbook/_ban-moi). Trang tĩnh đã có head đúng từ prerender, nên hàm
 * này chỉ ghi đè bằng đúng giá trị tương đương.
 */
function dat(selector, create, attr, value) {
  let el = document.head.querySelector(selector);
  if (!value) { if (el && selector.includes('robots')) el.remove(); return; }
  if (!el) { el = create(); document.head.appendChild(el); }
  el.setAttribute(attr, value);
}
const meta = (key, isProp) => () => { const el = document.createElement('meta'); el.setAttribute(isProp ? 'property' : 'name', key); return el; };

export function capNhatHead({ title, description, canonical, image, noindex = false }) {
  if (typeof document === 'undefined') return;
  if (title) document.title = title;
  dat('meta[name="description"]', meta('description'), 'content', description);
  dat('link[rel="canonical"]', () => { const el = document.createElement('link'); el.rel = 'canonical'; return el; }, 'href', canonical);
  dat('meta[property="og:title"]', meta('og:title', true), 'content', title);
  dat('meta[property="og:description"]', meta('og:description', true), 'content', description);
  dat('meta[property="og:url"]', meta('og:url', true), 'content', canonical);
  if (image) {
    dat('meta[property="og:image"]', meta('og:image', true), 'content', image);
    dat('meta[name="twitter:image"]', meta('twitter:image'), 'content', image);
  }
  dat('meta[name="robots"]', meta('robots'), 'content', noindex ? 'noindex' : '');
}
